import {
  BaseTable,
  Card,
  CommandButton,
  Loading,
  PaginationData,
  TableHeader
} from "components"
import moment from "moment"
import React, { useState } from "react"
import { convertNumber } from "utils"
import { Filter, Item, SummarySection } from "./components"
import { FilterType } from "./types"
import { defaultFilter, useExportPdfAllInvoice, useList } from "./utils"
import { exportExcelAllInvoice } from "./utils/functions"

export const dataContext = React.createContext({
  currentPage: 1,
  limit: 10,
  size: 1,
  total: 0,
  refetch() {}
})

export default function SalesOrderRegisterInvoice() {
  const [selected, setSelected] = useState<FilterType>(defaultFilter)
  const exportDateFormat = `${moment(selected.start_date).format(
    "DD/MM/YYYY"
  )} - ${moment(selected.end_date).format("DD/MM/YYYY")}`
  const { data, isLoading, refetch } = useList(selected)

  const subTotal = data?.payload?.reduce((acc, item) => acc + item.subtotal, 0)
  const paymentTotal = data?.payload?.reduce(
    (acc, item) => acc + item.payment,
    0
  )
  const balanceTotal = data?.payload?.reduce(
    (acc, item) => acc + item.balance_owing,
    0
  )

  const exportPdf = useExportPdfAllInvoice({
    data: data.payload,
    dateFilter: exportDateFormat
  })

  return (
    <section className="container my-2">
      <section>
        <Filter selected={selected} setSelected={setSelected} />

        <section className="mt-2">
          <div className="overflow-x-auto max-h-[calc(100vh-600px)]">
            <BaseTable>
              <TableHeader className="top-0 z-1 !bg-black !text-white">
                <tr className="uppercase">
                  <th>No</th>
                  <th>INVOICE ID#</th>
                  <th>REF SO ID#</th>
                  <th>DATE</th>
                  <th>CUSTOMER</th>
                  <th className="whitespace-pre-line">STATUS APPROVAL</th>
                  <th className="whitespace-pre-line">QTY DELIVERED</th>
                  <th>LOCATION</th>
                  <th>SUBTOTAL</th>
                  <th>PAYMENT</th>
                  <th className="whitespace-pre-line">BALANCE OWING</th>
                  <th>ACTION</th>
                </tr>
              </TableHeader>

              <tbody>
                <dataContext.Provider
                  value={{
                    currentPage: selected.page,
                    limit: selected.limit,
                    size: data.pagination_data.size,
                    total: selected.total,
                    refetch: refetch
                  }}>
                  {isLoading || data?.payload?.length === 0 ? (
                    <tr>
                      <td colSpan={13} className="text-center">
                        <Loading
                          loading={isLoading}
                          errorText={isLoading ? "" : "No data available"}
                        />
                      </td>
                    </tr>
                  ) : (
                    data?.payload?.map((item: any, key: number) => (
                      <Item data={item} index={key} />
                    ))
                  )}
                </dataContext.Provider>
              </tbody>
            </BaseTable>

            <div className="mt-5">
              <PaginationData
                data={data}
                pagination={selected}
                setPagination={setSelected}
              />
            </div>
          </div>
        </section>

        <section className="mt-2">
          <Card>
            <Card.Body className="flex flex-col gap-5">
              <section className="flex flex-wrap justify-between items-center gap-3">
                <section className="flex flex-wrap gap-3">
                  <CommandButton
                    actiontype="export"
                    onClick={() =>
                      exportExcelAllInvoice({
                        data: data.payload,
                        dateFilter: exportDateFormat
                      })
                    }
                  />
                  <CommandButton
                    actiontype="pdf"
                    onClick={exportPdf.handleExportPdf}
                  />
                </section>
                <section>
                  <SummarySection
                    label="SUMMARY SUBTOTAL"
                    value={convertNumber(subTotal)?.intoCurrency}
                  />
                  <SummarySection
                    label="SUMMARY PAYMENT"
                    value={convertNumber(paymentTotal)?.intoCurrency}
                  />
                  <SummarySection
                    label="SUMMARY BALANCE"
                    value={convertNumber(balanceTotal)?.intoCurrency}
                  />
                </section>
              </section>
            </Card.Body>
          </Card>
        </section>
      </section>
    </section>
  )
}
